import React from 'react';

export default function CookiesPolicy() {
  return (
    <div className="bg-white min-h-screen flex flex-col py-10 px-2">
      <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-xl border border-gray-200 p-8">
        <h1 className="text-3xl font-bold text-purple-600 mb-6 text-center">Cookies Policy</h1>

        <div className="space-y-8 text-gray-700">

          <div>
            <p>
              This Cookies Policy explains how <strong>Million2Trillion</strong> uses cookies and similar technologies
              to recognize you when you visit our platform. It explains what these technologies are and why we use them,
              as well as your rights to control our use of them.
            </p>
          </div>

          <div>
            <h2 className="text-xl text-blue-900 font-semibold mb-3">1. What Are Cookies?</h2>
            <p>
              Cookies are small data files that are placed on your computer or mobile device when you visit a website.
              Cookies are widely used by website owners to make their websites work, or to work more efficiently,
              as well as to provide reporting information.
            </p>
          </div>

          <div>
            <h2 className="text-xl text-blue-900 font-semibold mb-3">2. Why We Use Cookies</h2>
            <p>
              We use first and third-party cookies for several reasons. Some cookies are required for technical reasons
              for our platform to operate, and we refer to these as “essential” or “strictly necessary” cookies.
              Other cookies enable us to track and target the interests of our users to enhance the experience on our
              platform.
            </p>
          </div>

          <div>
            <h2 className="text-xl text-blue-900 font-semibold mb-3">3. Controlling Cookies</h2>
            <p>
              You have the right to decide whether to accept or reject cookies. You can set or amend your web browser
              controls to accept or refuse cookies. If you choose to reject cookies, you may still use our platform
              though your access to some functionality and areas may be restricted.
            </p>
          </div>

          <div>
            <h2 className="text-xl text-blue-900 font-semibold mb-3">4. Updates to This Policy</h2>
            <p>
              We may update this Cookies Policy from time to time to reflect changes to the cookies we use or for other
              operational, legal or regulatory reasons. Please revisit this page regularly to stay informed.
            </p>
          </div>

          <p className="mt-8 text-sm text-center text-gray-500 italic">
            Last updated: June 2025
          </p>
        </div>
      </div>
    </div>
  );
}
